// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JlMu","index":"styles_index__oM4V5"};